/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchDto } from './BranchDto';
import {
    BranchDtoFromJSON,
    BranchDtoFromJSONTyped,
    BranchDtoToJSON,
    BranchDtoToJSONTyped,
} from './BranchDto';

/**
 * 
 * @export
 * @interface PracticeProfileDetailDto
 */
export interface PracticeProfileDetailDto {
    /**
     * Practice ID (Firebase UID)
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    id: string;
    /**
     * Practice name
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    practiceName: string;
    /**
     * Practice email
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    email: string;
    /**
     * Practice phone number
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    phoneNumber: string;
    /**
     * Practice fax number
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    faxNumber?: string;
    /**
     * Array of branch information
     * @type {Array<BranchDto>}
     * @memberof PracticeProfileDetailDto
     */
    branches: Array<BranchDto>;
    /**
     * Provider profile picture URL
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    profilePicture?: string;
    /**
     * Provider first name
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    firstName: string;
    /**
     * Provider middle name
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    middleName?: string;
    /**
     * Provider last name
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    lastName: string;
    /**
     * National Provider Identifier (NPI)
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    npi: string;
    /**
     * Provider specialties
     * @type {Array<string>}
     * @memberof PracticeProfileDetailDto
     */
    specialty?: Array<string>;
    /**
     * Provider is active
     * @type {boolean}
     * @memberof PracticeProfileDetailDto
     */
    isActive?: boolean;
    /**
     * Practice ID (UUID) that this provider belongs to
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    practiceId?: string;
    /**
     * RXNT Client ID for e-prescribing integration
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    rxntClientId?: string;
    /**
     * RXNT Client Secret for e-prescribing integration
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    rxntClientSecret?: string;
    /**
     * RXNT Doctor ID for e-prescribing integration
     * @type {string}
     * @memberof PracticeProfileDetailDto
     */
    rxntDoctorId?: string;
}

/**
 * Check if a given object implements the PracticeProfileDetailDto interface.
 */
export function instanceOfPracticeProfileDetailDto(value: object): value is PracticeProfileDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practiceName' in value) || value['practiceName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function PracticeProfileDetailDtoFromJSON(json: any): PracticeProfileDetailDto {
    return PracticeProfileDetailDtoFromJSONTyped(json, false);
}

export function PracticeProfileDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeProfileDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practiceName': json['practiceName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'faxNumber': json['faxNumber'] == null ? undefined : json['faxNumber'],
        'branches': ((json['branches'] as Array<any>).map(BranchDtoFromJSON)),
        'profilePicture': json['profilePicture'] == null ? undefined : json['profilePicture'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'npi': json['npi'],
        'specialty': json['specialty'] == null ? undefined : json['specialty'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'practiceId': json['practiceId'] == null ? undefined : json['practiceId'],
        'rxntClientId': json['rxntClientId'] == null ? undefined : json['rxntClientId'],
        'rxntClientSecret': json['rxntClientSecret'] == null ? undefined : json['rxntClientSecret'],
        'rxntDoctorId': json['rxntDoctorId'] == null ? undefined : json['rxntDoctorId'],
    };
}

export function PracticeProfileDetailDtoToJSON(json: any): PracticeProfileDetailDto {
    return PracticeProfileDetailDtoToJSONTyped(json, false);
}

export function PracticeProfileDetailDtoToJSONTyped(value?: PracticeProfileDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practiceName': value['practiceName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'faxNumber': value['faxNumber'],
        'branches': ((value['branches'] as Array<any>).map(BranchDtoToJSON)),
        'profilePicture': value['profilePicture'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'npi': value['npi'],
        'specialty': value['specialty'],
        'isActive': value['isActive'],
        'practiceId': value['practiceId'],
        'rxntClientId': value['rxntClientId'],
        'rxntClientSecret': value['rxntClientSecret'],
        'rxntDoctorId': value['rxntDoctorId'],
    };
}

